export default {"src":"/_next/static/media/logoCut.745b04a2.svg","height":399,"width":1276,"blurWidth":0,"blurHeight":0};